import { create } from 'zustand';
import { t } from 'i18next';
import db from '../../db';
import { httpService } from '../utils/apiService';

const ADMIN_ROLES = ['ADMIN'];

export const useOperatorStore = create((set, get) => ({
  operatorId: null,
  name: null,
  /** false until default/session operator is bound after auth */
  isOperatorReady: false,
  operatorBindError: null,

  setOperatorID: async (id, name) => {
    const normalizedId = id != null ? String(id) : null;
    if (normalizedId) {
      await db.operator.put({ key: 'operatorId', value: normalizedId });
      await db.operator.put({ key: 'name', value: name ?? null });
    } else {
      await db.operator.clear();
    }
    set({
      operatorId: normalizedId,
      name: name ?? null,
      isOperatorReady: !!normalizedId,
      operatorBindError: normalizedId ? null : get().operatorBindError,
    });
  },

  clearOperatorID: async () => {
    await db.operator.clear();
    set({
      operatorId: null,
      name: null,
      isOperatorReady: false,
      operatorBindError: null,
    });
  },

  /**
   * Bind operator for the current user.
   * ADMIN: always fetch GET /operator/default (ignores IndexedDB).
   */
  bindOperatorForUser: async (user) => {
    if (!user) {
      set({
        operatorId: null,
        name: null,
        isOperatorReady: false,
        operatorBindError: null,
      });
      return;
    }

    if (ADMIN_ROLES.includes(user.role)) {
      try {
        await db.operator.clear();
        const response = await httpService.get('operator/default');
        const op = response?.data?.data;
        if (!op?._id) {
          throw new Error(t('common:defaultOperatorNotFound'));
        }
        await get().setOperatorID(op._id, op.name);
      } catch (e) {
        const message =
          e?.response?.data?.message ||
          e?.message ||
          t('common:defaultOperatorLoadFailed');
        console.error('[operator] bind failed:', message);
        set({
          operatorId: null,
          name: null,
          isOperatorReady: false,
          operatorBindError: message,
        });
      }
      return;
    }

    set({ isOperatorReady: true, operatorBindError: null });
  },
}));
